'use strict';

/** @type {(value: unknown) => value is null | undefined | string | symbol | number | boolean | bigint} */
module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ./~/es-to-primitive/helpers/isPrimitive.js
// module id = 1493
// module chunks = 1